import {
  CLARITY_TAG_NAME,
  CLARITY_TAG_VALUE,
  DEFAULT_CONFIG,
} from '@/constants/constants';
import { IPlaceholderField } from '@/interfaces/placeholder-field';
import { usePdfEditorStore } from '@/store';
import { setClarityCustomTag } from '@/utils/clarity.utils';
import clsx from 'clsx';
import { Resizable, ResizeCallback } from 're-resizable';
import { useEffect } from 'react';
import FileUploadContent from './FileUploadContent';
import { getFieldFontSize } from '@/utils/field-font-size';

interface FileUploadEditProps {
  item: any;
  resizeable?: boolean;
  setIsResizing?: (isResizing: boolean) => void;
}

const FileUploadEdit = ({
  item,
  resizeable = true,
  setIsResizing,
}: FileUploadEditProps) => {
  const actions = usePdfEditorStore((state) => state.placeholders.actions);
  const backgroundColor = item.color ?? item.signer?.color ?? 'transparent';

  useEffect(() => {
    setClarityCustomTag(
      CLARITY_TAG_NAME.FILE_UPLOAD_COMPONENT,
      CLARITY_TAG_VALUE.FILE_UPLOAD_COMPONENT,
    );
  }, []);

  const handleResizeStart = () => {
    setIsResizing?.(true);
  };

  const handleResizeEnd: (item: IPlaceholderField) => ResizeCallback =
    (item) => (_e, _dir, _ref, d) => {
      setIsResizing?.(false);
      const width = (item.width || DEFAULT_CONFIG.FILE_UPLOAD.width) + d.width;
      const height =
        (item.height || DEFAULT_CONFIG.FILE_UPLOAD.height) + d.height;
      actions.updateFieldSize(item, { width, height });
    };

  const enable = resizeable
    ? {
        top: false,
        right: item?.isActive,
        bottom: item?.isActive,
        left: false,
        topRight: false,
        bottomRight: item?.isActive,
        bottomLeft: false,
        topLeft: false,
      }
    : false;

  return (
    <div
      className={clsx(
        'tw-relative',
        'tw-rounded-sm tw-border tw-border-solid',
        'tw-transition-all tw-duration-200',
        item.isActive ? 'tw-border-active' : 'tw-border-gray-200',
        'hover:tw-border-active',
      )}
    >
      <Resizable
        size={{
          height: item.height || DEFAULT_CONFIG.FILE_UPLOAD.height,
          width: item.width || DEFAULT_CONFIG.FILE_UPLOAD.width,
        }}
        lockAspectRatio={false}
        enable={enable}
        onResizeStart={handleResizeStart}
        onResizeStop={handleResizeEnd(item)}
        minHeight={DEFAULT_CONFIG.FILE_UPLOAD.height}
        minWidth={DEFAULT_CONFIG.FILE_UPLOAD.width}
      >
        <FileUploadContent
          backgroundColor={backgroundColor}
          fontSize={getFieldFontSize(item)}
          label={item.label}
        />
      </Resizable>
    </div>
  );
};

export default FileUploadEdit;
